import React, {useMemo, useCallback} from "react";

import {Input} from "reactstrap";
import {InputType} from "reactstrap/types/lib/Input";

interface InputTextProps {
    value: null | string;
    id: string;
    placeholder: null | string;
    onChange: (value: string) => void;
    required: false | boolean;
    maxLength: null | number;
    className: null | string;
    autoFocus: false | boolean;
    disabled?: boolean;
    pattern?: string;
    type?: InputType;
    onKeyDown?: (value: any) => void;
    onPaste?: (value: any) => void;
    autocomplete?: string
}

const InputText = React.memo(({
                       id,
                       placeholder,
                       value,
                       onChange,
                       required,
                       maxLength,
                       className,
                       autoFocus,
                       disabled = false,
                       pattern,
                       type = 'text',
                       onKeyDown,
                       onPaste,
                       autocomplete = "off"
                   }: InputTextProps) => {

    const regexp = useMemo(() => pattern ? new RegExp(pattern) : null, [pattern]);




    const handleKeyDown = useCallback((event: React.KeyboardEvent<HTMLInputElement>) => {
        const ignoreKeys = ["Backspace", "Tab", "Enter"];

        if (regexp && !ignoreKeys.includes(event.key)) {
            if (!event.key.match(regexp)) {
                event.preventDefault();
                return;
            }
        }

        if (onKeyDown) {
            onKeyDown(event);
        }
    }, [regexp, onKeyDown]);

    const handleChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
        onChange(e.target.value);
    }, [onChange]);

    return (
        <Input
            type={type}
            className={className || "form-control"}
            id={id}
            placeholder={placeholder || ""}
            value={value || ''}
            onChange={handleChange}
            onKeyDown={handleKeyDown}
            maxLength={maxLength || undefined}
            autoComplete={autocomplete}
            required={required}
            autoFocus={autoFocus}
            disabled={disabled}
            onPaste={onPaste || undefined}
        />
    );
});
export default InputText;
